<template>
  <div class="index_vue">
    <Row v-show="wxState">
      <topP></topP>
    </Row>
    <div class="flowIndex_leftNav" v-if="wxState">
      <leftNav></leftNav>
    </div>
    <div id="zhuRight" class="flowIndex_right">
      <router-view></router-view>
      <!--<div style="width:300px;margin:0 auto; padding:20px 0;position: absolute;left: 50%;bottom: 0;margin-left: -150px;z-index: -3;">
	     <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/footImg.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44060402000992号</p ></a >
	    </div>-->
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import leftNav from "./leftNav";
import topP from "./top";
export default {
  data() {
    return {
      wxState: false,
      spanV: 16,
    }
  },
  computed: {
	    ...mapState(["routeArr","xcxUser","xcxId","isDinner"]),
	 },
  mounted(){
  	var index_vue = document.getElementsByClassName("index_vue")[0]
  	var footer = document.getElementsByTagName("footer")[0];
  	var ele = document.getElementById("zhuRight");
    if(this.$route.path.indexOf("wx") != -1 ){
      this.wxState = false;
      this.spanV = 24;
      ele.classList.add("flowIndex_right2");
      ele.classList.remove("flowIndex_right3");
      footer.style.display = "none";
      index_vue.style.height = "calc(100% - 65px)"
    }else if(this.$route.path.indexOf("bigScreen") != -1){
      this.wxState = false;
      this.spanV = 24;
//      footer.style.display = "none";
      ele.classList.add("flowIndex_right3")
      ele.classList.remove("flowIndex_right2")
      console.log(ele.classList);
      index_vue.style.height = "100%"
    }else{
      this.wxState = true;
      this.spanV = 0;
      ele.classList.remove("flowIndex_right2")
//      footer.style.display = "block";
      ele.classList.remove("flowIndex_right3")
      index_vue.style.height = "calc(100% - 65px)"
    };
    if(this.$route.path.indexOf("wxSend") != -1 ){
    	document.getElementsByTagName("title")[0].innerText = "账号绑定333";
	}else if(this.$route.path.indexOf("wxProperty") != -1 ||this.$route.path.indexOf("wxAllProperty") != -1 ){
        document.getElementsByTagName("title")[0].innerText = "资产信息";
	}else if(this.$route.path.indexOf("wxDinner") != -1 && window.localStorage.getItem("isLogin") == "true"){
    	document.getElementsByTagName("title")[0].innerText = "个人用餐";
	}else if(!this.wxState){
    	document.getElementsByTagName("title")[0].innerText = "账号绑定";
	}else if(this.wxState){
        document.getElementsByTagName("title")[0].innerText = "账号解绑222";
    }
	if(this.$route.path.indexOf("wx") == -1){
        document.getElementsByTagName("title")[0].innerText = "JM内务管理";
	    }
  },
  components: {
    leftNav,
    topP
  },
  watch:{
    $route( to , from ){
  		var index_vue = document.getElementsByClassName("index_vue")[0]
  		var footer = document.getElementsByTagName("footer")[0];
    	this.SET_DINNER(false);
  		if(to.path.indexOf("wxDinner") != -1){
    		this.SET_DINNER(true);
  		}
    	if(to.path.indexOf("wx") != -1){
    			this.ADD_RETOR(to.path);
      		footer.style.display = "none";
    	}else{
      		footer.style.display = "block";
    	}
      if(from.path.indexOf("wxSend") != -1 && this.xcxUser == ""){
        this.$router.replace('/data/wxSend/'+this.xcxId);
        alert("请登录绑定或点右上退出");
      }
  		var ele = document.getElementById("zhuRight");
  		if(to.path.indexOf("wxDinner") != -1 && from.path.indexOf("wxProperty") != -1){
  			this.$router.push(from.path);
  		}
      if(this.$route.path.indexOf("wx") != -1 ){
	      this.wxState = false;
	      this.spanV = 24;
	      ele.classList.add("flowIndex_right2");
	      ele.classList.remove("flowIndex_right3")
      	index_vue.style.height = "calc(100% - 65px)"
	    }else if(this.$route.path.indexOf("bigScreen") != -1){
	    	this.wxState = false;
	      this.spanV = 24;
	      ele.classList.add("flowIndex_right3")
	      ele.classList.remove("flowIndex_right2")
      	index_vue.style.height = "100%"
	    }else{
	      this.wxState = true;
	      this.spanV = 0;
	      ele.classList.remove("flowIndex_right2")
	      ele.classList.remove("flowIndex_right3")
      	index_vue.style.height = "calc(100% - 65px)"
	    }
	    if(this.$route.path.indexOf("wxDinner") != -1 ){
    		document.getElementsByTagName("title")[0].innerText = "个人用餐";
	    }else if(this.$route.path.indexOf("wxProperty") != -1 ||this.$route.path.indexOf("wxAllProperty") != -1 ){
        document.getElementsByTagName("title")[0].innerText = "资产信息";
      }else if(this.$route.path.indexOf("wxSend") != -1 && window.localStorage.getItem("isLogin") == "true"){
        document.getElementsByTagName("title")[0].innerText = "账号解绑";
      }else if(this.$route.path.indexOf("wxSend") != -1 && window.localStorage.getItem("isLogin") == "true"){
        document.getElementsByTagName("title")[0].innerText = "账号绑定";
      }
	    if(this.$route.path.indexOf("wx") == -1){
        document.getElementsByTagName("title")[0].innerText = "JM内务管理";
	    }
    }
  },
  methods: {
    ...mapMutations(["ADD_RETOR","SET_DINNER"])
  }
}
</script>

<style lang="scss">
	#app{
    height: 100%;
}
.nui-scroll::-webkit-scrollbar {
    width: 8px;//表示垂直滚动条的宽度
    height: 8px;//表示水平滚动条的高度
}
/*正常情况下滑块的样式*/
.nui-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,.05);
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*鼠标悬浮在该类指向的控件上时滑块的样式*/
.nui-scroll:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0,0,0,.2);
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*鼠标悬浮在滑块上时滑块的样式*/
.nui-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0,0,0,.4);
    -webkit-box-shadow: inset 1px 1px 0 rgba(0,0,0,.1);
}
/*正常时候的主干部分*/
.nui-scroll::-webkit-scrollbar-track {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0);
    background-color: white;
}
/*鼠标悬浮在滚动条上的主干部分*/
.nui-scroll::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.4);
    background-color: rgba(0,0,0,.01);
}
.nui-scroll{
    overflow: auto;/*当内容溢出时显示滚动条*/
}
.index_vue{
    height:calc(100% - 65px);
  .flowIndex_leftNav {
    width: 240px;
    height: 100%;
    max-height: 100%;
    /*overflow-y: scroll;*/
    float: left;
  }
  .flowIndex_right {
    width: calc(100% - 240px);
    float: left;
    overflow-x: hidden;
    padding-left: 2px;
  }
  .flowIndex_right2 {
    width: 100%;
    float: left;
    overflow-x: hidden;
    padding-left: 2px;
    min-height: 100%;
  }
  .flowIndex_right3 {
  	width: 100%;
  	height: 100%;
    float: left;
    overflow: hidden;
    padding-left: 2px;
  }
  .\100vh{
  	height: 100vh !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/index.vue